import { Button } from '@pelckmans/business-components/components/button';
import { Dialog, ModalDialog } from '@pelckmans/business-components/components/dialog';
import { Tabpanel } from '@pelckmans/business-components/components/tabs';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import WordlistContext from './_contexts/WordlistContext';
import WordlistHierarchyList from './WordlistHierarchyList';
import favoritesImage from '../../../assets/images/favorieten.png';
import useWordlistWords from './_hooks/useWordlistWords';
import WordlistViewModeContext, { WordlistViewMode } from './_contexts/WordlistViewModeContext';

type ConfirmClearFavoritesModalProps = {
  id: string;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmClearFavoritesModal = ({ id, onClose, onConfirm }: ConfirmClearFavoritesModalProps) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <ModalDialog onClose={onClose} id={id} closeTitle={t('ACTIONS.CLOSE')} size="small">
      <Dialog.Header title={t('MODULES.MATERIAL.COMPONENTS.WORD_LISTS.CLEAR_MY_WORDLIST_DIALOG.TITLE')} />
      <Dialog.Body>{t('MODULES.MATERIAL.COMPONENTS.WORD_LISTS.CLEAR_MY_WORDLIST_DIALOG.MESSAGE')}</Dialog.Body>
      <Dialog.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t('ACTIONS.NO')}
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          {t('ACTIONS.YES')}
        </Button>
      </Dialog.Footer>
    </ModalDialog>
  );
};

export default function WordlistFavoritesTab() {
  const { t } = useTranslation();
  const words = useWordlistWords();

  const { clearFavoriteWords } = useContext(WordlistContext);
  const { setViewMode } = useContext(WordlistViewModeContext);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  return (
    <>
      <Tabpanel tabId="favorites" className="wordlist__tab">
        {(words || []).length > 0 ? (
          <>
            <header className="wordlist__header wordlist__header--level-0 wordlist__header--favorites">
              {t('MODULES.MATERIAL.COMPONENTS.WORD_LISTS.FAVORITE_TITLE')}
              <button className="wordlist__header-btn" onClick={() => setShowConfirmationModal(true)}>
                <svg className="icon" role="img">
                  <use href="#icon-trash" />
                </svg>
              </button>
            </header>

            <WordlistHierarchyList />
            <div className="wordlist__actions">
              <Button variant="primary" onClick={() => setViewMode(WordlistViewMode.FOCUS)} size="small">
                {t('MODULES.MATERIAL.COMPONENTS.WORD_LISTS.LEARN_WORDS')}
              </Button>
            </div>
          </>
        ) : (
          <div className="wordlist__no-favorites">
            {t('MODULES.MATERIAL.COMPONENTS.WORD_LISTS.NO_FAVORITES_SELECTED')}
            <img src={favoritesImage} alt={t('MODULES.MATERIAL.COMPONENTS.WORD_LISTS.FAVORITE_TITLE')} />
          </div>
        )}
      </Tabpanel>

      {showConfirmationModal && (
        <ConfirmClearFavoritesModal
          id="confirm-clear-favorites-modal"
          onClose={() => setShowConfirmationModal(false)}
          onConfirm={clearFavoriteWords}
        />
      )}
    </>
  );
}
